module.exports = __webpack_public_path__ + "svg/close-grey.svg?e07d2674398155b86611df244caba87a";